export default "__VITE_ASSET__D_Zsv31s__"